export default {
	ab: {
		name: 'Abkhaz',
		nativeName: 'аҧсуа',
	},
	aa: {
		name: 'Afar',
		nativeName: 'Afaraf',
	},
	af: {
		name: 'Afrikaans',
		nativeName: 'Afrikaans',
	},
	ak: {
		name: 'Akan',
		nativeName: 'Akan',
	},
	sq: {
		name: 'Albanian',
		nativeName: 'Shqip',
	},
	am: {
		name: 'Amharic',
		nativeName: 'አማርኛ',
	},
	ar: {
		name: 'Arabic',
		nativeName: 'العربية',
	},
	an: {
		name: 'Aragonese',
		nativeName: 'Aragonés',
	},
	hy: {
		name: 'Armenian',
		nativeName: 'Հայերեն',
	},
	as: {
		name: 'Assamese',
		nativeName: 'অসমীয়া',
	},
	av: {
		name: 'Avaric',
		nativeName: 'авармацӀ,магӀарулмацӀ',
	},
	ae: {
		name: 'Avestan',
		nativeName: 'avesta',
	},
	ay: {
		name: 'Aymara',
		nativeName: 'aymararu',
	},
	az: {
		name: 'Azerbaijani',
		nativeName: 'azərbaycandili',
	},
	bm: {
		name: 'Bambara',
		nativeName: 'bamanankan',
	},
	ba: {
		name: 'Bashkir',
		nativeName: 'башҡорттеле',
	},
	eu: {
		name: 'Basque',
		nativeName: 'euskara,euskera',
	},
	be: {
		name: 'Belarusian',
		nativeName: 'Беларуская',
	},
	bn: {
		name: 'Bengali',
		nativeName: 'বাংলা',
	},
	bh: {
		name: 'Bihari',
		nativeName: 'भोजपुरी',
	},
	bi: {
		name: 'Bislama',
		nativeName: 'Bislama',
	},
	bs: {
		name: 'Bosnian',
		nativeName: 'bosanskijezik',
	},
	br: {
		name: 'Breton',
		nativeName: 'brezhoneg',
	},
	bg: {
		name: 'Bulgarian',
		nativeName: 'българскиезик',
	},
	my: {
		name: 'Burmese',
		nativeName: 'ဗမာစာ',
	},
	ca: {
		name: 'Catalan;Valencian',
		nativeName: 'Català',
	},
	ch: {
		name: 'Chamorro',
		nativeName: 'Chamoru',
	},
	ce: {
		name: 'Chechen',
		nativeName: 'нохчийнмотт',
	},
	ny: {
		name: 'Chichewa;Chewa;Nyanja',
		nativeName: 'chiCheŵa,chinyanja',
	},
	zh: {
		name: 'Chinese',
		nativeName: '中文(Zhōngwén),汉语,漢語',
	},
	cv: {
		name: 'Chuvash',
		nativeName: 'чӑвашчӗлхи',
	},
	kw: {
		name: 'Cornish',
		nativeName: 'Kernewek',
	},
	co: {
		name: 'Corsican',
		nativeName: 'corsu,linguacorsa',
	},
	cr: {
		name: 'Cree',
		nativeName: 'ᓀᐦᐃᔭᐍᐏᐣ',
	},
	hr: {
		name: 'Croatian',
		nativeName: 'hrvatski',
	},
	cs: {
		name: 'Czech',
		nativeName: 'Čeština',
	},
	da: {
		name: 'Danish',
		nativeName: 'Dansk',
	},
	dv: {
		name: 'Divehi;Dhivehi;Maldivian;',
		nativeName: 'ދިވެހި',
	},
	nl: {
		iso: 'nl',
		name: 'Dutch',
		nativeName: 'Nederlands',
	},
	en: {
		iso: 'en',
		name: 'English',
		nativeName: 'English',
	},
	eo: {
		name: 'Esperanto',
		nativeName: 'Esperanto',
	},
	et: {
		name: 'Estonian',
		nativeName: 'eesti,eestikeel',
	},
	ee: {
		name: 'Ewe',
		nativeName: 'Eʋegbe',
	},
	fo: {
		name: 'Faroese',
		nativeName: 'føroyskt',
	},
	fj: {
		name: 'Fijian',
		nativeName: 'vosaVakaviti',
	},
	fi: {
		name: 'Finnish',
		nativeName: 'suomi,suomenkieli',
	},
	fr: {
		iso: 'fr',
		name: 'French',
		nativeName: 'Français',
	},
	ff: {
		name: 'Fula;Fulah;Pulaar;Pular',
		nativeName: 'Fulfulde,Pulaar,Pular',
	},
	gl: {
		name: 'Galician',
		nativeName: 'Galego',
	},
	ka: {
		name: 'Georgian',
		nativeName: 'ქართული',
	},
	de: {
		iso: 'de',
		name: 'German',
		nativeName: 'Deutsch',
	},
	el: {
		name: 'Greek,Modern',
		nativeName: 'Ελληνικά',
	},
	gn: {
		name: 'Guaraní',
		nativeName: 'Avañeẽ',
	},
	gu: {
		name: 'Gujarati',
		nativeName: 'ગુજરાતી',
	},
	ht: {
		name: 'Haitian;HaitianCreole',
		nativeName: 'Kreyòlayisyen',
	},
	ha: {
		name: 'Hausa',
		nativeName: 'Hausa,هَوُسَ',
	},
	he: {
		name: 'Hebrew(modern)',
		nativeName: 'עברית',
	},
	hz: {
		name: 'Herero',
		nativeName: 'Otjiherero',
	},
	hi: {
		name: 'Hindi',
		nativeName: 'हिन्दी,हिंदी',
	},
	ho: {
		name: 'HiriMotu',
		nativeName: 'HiriMotu',
	},
	hu: {
		name: 'Hungarian',
		nativeName: 'Magyar',
	},
	ia: {
		name: 'Interlingua',
		nativeName: 'Interlingua',
	},
	id: {
		name: 'Indonesian',
		nativeName: 'BahasaIndonesia',
	},
	ie: {
		name: 'Interlingue',
		nativeName: 'OriginallycalledOccidental;thenInterlingueafterWWII',
	},
	ga: {
		name: 'Irish',
		nativeName: 'Gaeilge',
	},
	ig: {
		name: 'Igbo',
		nativeName: 'AsụsụIgbo',
	},
	ik: {
		name: 'Inupiaq',
		nativeName: 'Iñupiaq,Iñupiatun',
	},
	io: {
		name: 'Ido',
		nativeName: 'Ido',
	},
	is: {
		name: 'Icelandic',
		nativeName: 'Íslenska',
	},
	it: {
		name: 'Italian',
		nativeName: 'Italiano',
	},
	iu: {
		name: 'Inuktitut',
		nativeName: 'ᐃᓄᒃᑎᑐᑦ',
	},
	ja: {
		name: 'Japanese',
		nativeName: '日本語(にほんご／にっぽんご)',
	},
	jv: {
		name: 'Javanese',
		nativeName: 'basaJawa',
	},
	kl: {
		name: 'Kalaallisut,Greenlandic',
		nativeName: 'kalaallisut,kalaallitoqaasii',
	},
	kn: {
		name: 'Kannada',
		nativeName: 'ಕನ್ನಡ',
	},
	kr: {
		name: 'Kanuri',
		nativeName: 'Kanuri',
	},
	ks: {
		name: 'Kashmiri',
		nativeName: 'कश्मीरी,كشميري‎',
	},
	kk: {
		name: 'Kazakh',
		nativeName: 'Қазақтілі',
	},
	km: {
		name: 'Khmer',
		nativeName: 'ភាសាខ្មែរ',
	},
	ki: {
		name: 'Kikuyu,Gikuyu',
		nativeName: 'Gĩkũyũ',
	},
	rw: {
		name: 'Kinyarwanda',
		nativeName: 'Ikinyarwanda',
	},
	ky: {
		name: 'Kirghiz,Kyrgyz',
		nativeName: 'кыргызтили',
	},
	kv: {
		name: 'Komi',
		nativeName: 'комикыв',
	},
	kg: {
		name: 'Kongo',
		nativeName: 'KiKongo',
	},
	ko: {
		name: 'Korean',
		nativeName: '한국어(韓國語),조선말(朝鮮語)',
	},
	ku: {
		name: 'Kurdish',
		nativeName: 'Kurdî,كوردی‎',
	},
	kj: {
		name: 'Kwanyama,Kuanyama',
		nativeName: 'Kuanyama',
	},
	la: {
		name: 'Latin',
		nativeName: 'latine,lingualatina',
	},
	lb: {
		name: 'Luxembourgish,Letzeburgesch',
		nativeName: 'Lëtzebuergesch',
	},
	lg: {
		name: 'Luganda',
		nativeName: 'Luganda',
	},
	li: {
		name: 'Limburgish,Limburgan,Limburger',
		nativeName: 'Limburgs',
	},
	ln: {
		name: 'Lingala',
		nativeName: 'Lingála',
	},
	lo: {
		name: 'Lao',
		nativeName: 'ພາສາລາວ',
	},
	lt: {
		name: 'Lithuanian',
		nativeName: 'lietuviųkalba',
	},
	lu: {
		name: 'Luba-Katanga',
		nativeName: '',
	},
	lv: {
		name: 'Latvian',
		nativeName: 'latviešuvaloda',
	},
	gv: {
		name: 'Manx',
		nativeName: 'Gaelg,Gailck',
	},
	mk: {
		name: 'Macedonian',
		nativeName: 'македонскијазик',
	},
	mg: {
		name: 'Malagasy',
		nativeName: 'Malagasyfiteny',
	},
	ms: {
		name: 'Malay',
		nativeName: 'bahasaMelayu,بهاسملايو‎',
	},
	ml: {
		name: 'Malayalam',
		nativeName: 'മലയാളം',
	},
	mt: {
		name: 'Maltese',
		nativeName: 'Malti',
	},
	mi: {
		name: 'Māori',
		nativeName: 'tereoMāori',
	},
	mr: {
		name: 'Marathi(Marāṭhī)',
		nativeName: 'मराठी',
	},
	mh: {
		name: 'Marshallese',
		nativeName: 'KajinM̧ajeļ',
	},
	mn: {
		name: 'Mongolian',
		nativeName: 'монгол',
	},
	na: {
		name: 'Nauru',
		nativeName: 'EkakairũNaoero',
	},
	nv: {
		name: 'Navajo,Navaho',
		nativeName: 'Dinébizaad,Dinékʼehǰí',
	},
	nb: {
		name: 'NorwegianBokmål',
		nativeName: 'Norskbokmål',
	},
	nd: {
		name: 'NorthNdebele',
		nativeName: 'isiNdebele',
	},
	ne: {
		name: 'Nepali',
		nativeName: 'नेपाली',
	},
	ng: {
		name: 'Ndonga',
		nativeName: 'Owambo',
	},
	nn: {
		name: 'NorwegianNynorsk',
		nativeName: 'Norsknynorsk',
	},
	no: {
		name: 'Norwegian',
		nativeName: 'Norsk',
	},
	ii: {
		name: 'Nuosu',
		nativeName: 'ꆈꌠ꒿Nuosuhxop',
	},
	nr: {
		name: 'SouthNdebele',
		nativeName: 'isiNdebele',
	},
	oc: {
		name: 'Occitan',
		nativeName: 'Occitan',
	},
	oj: {
		name: 'Ojibwe,Ojibwa',
		nativeName: 'ᐊᓂᔑᓈᐯᒧᐎᓐ',
	},
	cu: {
		name: 'OldChurchSlavonic,ChurchSlavic,ChurchSlavonic,OldBulgarian,OldSlavonic',
		nativeName: 'ѩзыкъсловѣньскъ',
	},
	om: {
		name: 'Oromo',
		nativeName: 'AfaanOromoo',
	},
	or: {
		name: 'Oriya',
		nativeName: 'ଓଡ଼ିଆ',
	},
	os: {
		name: 'Ossetian,Ossetic',
		nativeName: 'иронæвзаг',
	},
	pa: {
		name: 'Panjabi,Punjabi',
		nativeName: 'ਪੰਜਾਬੀ,پنجابی‎',
	},
	pi: {
		name: 'Pāli',
		nativeName: 'पाऴि',
	},
	fa: {
		name: 'Persian',
		nativeName: 'فارسی',
	},
	pl: {
		name: 'Polish',
		nativeName: 'Polski',
	},
	ps: {
		name: 'Pashto,Pushto',
		nativeName: 'پښتو',
	},
	pt: {
		name: 'Portuguese',
		nativeName: 'Português',
	},
	qu: {
		name: 'Quechua',
		nativeName: 'RunaSimi,Kichwa',
	},
	rm: {
		name: 'Romansh',
		nativeName: 'rumantschgrischun',
	},
	rn: {
		name: 'Kirundi',
		nativeName: 'kiRundi',
	},
	ro: {
		name: 'Romanian,Moldavian,Moldovan',
		nativeName: 'Română',
	},
	ru: {
		name: 'Russian',
		nativeName: 'русскийязык',
	},
	sa: {
		name: 'Sanskrit(Saṁskṛta)',
		nativeName: 'संस्कृतम्',
	},
	sc: {
		name: 'Sardinian',
		nativeName: 'Sardu',
	},
	sd: {
		name: 'Sindhi',
		nativeName: 'सिन्धी, سنڌي،سندھی‎',
	},
	se: {
		name: 'NorthernSami',
		nativeName: 'Davvisámegiella',
	},
	sm: {
		name: 'Samoan',
		nativeName: 'gaganafaaSamoa',
	},
	sg: {
		name: 'Sango',
		nativeName: 'yângâtîsängö',
	},
	sr: {
		name: 'Serbian',
		nativeName: 'српскијезик',
	},
	gd: {
		name: 'ScottishGaelic;Gaelic',
		nativeName: 'Gàidhlig',
	},
	sn: {
		name: 'Shona',
		nativeName: 'chiShona',
	},
	si: {
		name: 'Sinhala,Sinhalese',
		nativeName: 'සිංහල',
	},
	sk: {
		name: 'Slovak',
		nativeName: 'Slovenčina',
	},
	sl: {
		name: 'Slovene',
		nativeName: 'Slovenščina',
	},
	so: {
		name: 'Somali',
		nativeName: 'Soomaaliga,afSoomaali',
	},
	st: {
		name: 'SouthernSotho',
		nativeName: 'Sesotho',
	},
	es: {
		name: 'Spanish;Castilian',
		nativeName: 'Español, Castellano',
	},
	su: {
		name: 'Sundanese',
		nativeName: 'BasaSunda',
	},
	sw: {
		name: 'Swahili',
		nativeName: 'Kiswahili',
	},
	ss: {
		name: 'Swati',
		nativeName: 'SiSwati',
	},
	sv: {
		name: 'Swedish',
		nativeName: 'Svenska',
	},
	ta: {
		name: 'Tamil',
		nativeName: 'தமிழ்',
	},
	te: {
		name: 'Telugu',
		nativeName: 'తెలుగు',
	},
	tg: {
		name: 'Tajik',
		nativeName: 'тоҷикӣ,toğikī,تاجیکی‎',
	},
	th: {
		name: 'Thai',
		nativeName: 'ไทย',
	},
	ti: {
		name: 'Tigrinya',
		nativeName: 'ትግርኛ',
	},
	bo: {
		name: 'TibetanStandard,Tibetan,Central',
		nativeName: 'བོད་ཡིག',
	},
	tk: {
		name: 'Turkmen',
		nativeName: 'Türkmen,Түркмен',
	},
	tl: {
		name: 'Tagalog',
		nativeName: 'WikangTagalog',
	},
	tn: {
		name: 'Tswana',
		nativeName: 'Setswana',
	},
	to: {
		name: 'Tonga(TongaIslands)',
		nativeName: 'fakaTonga',
	},
	tr: {
		name: 'Turkish',
		nativeName: 'Türkçe',
	},
	ts: {
		name: 'Tsonga',
		nativeName: 'Xitsonga',
	},
	tt: {
		name: 'Tatar',
		nativeName: 'татарча,tatarça,تاتارچا‎',
	},
	tw: {
		name: 'Twi',
		nativeName: 'Twi',
	},
	ty: {
		name: 'Tahitian',
		nativeName: 'ReoTahiti',
	},
	ug: {
		name: 'Uighur,Uyghur',
		nativeName: 'Uyƣurqə,ئۇيغۇرچە‎',
	},
	uk: {
		name: 'Ukrainian',
		nativeName: 'українська',
	},
	ur: {
		name: 'Urdu',
		nativeName: 'اردو',
	},
	uz: {
		name: 'Uzbek',
		nativeName: 'zbek,Ўзбек,أۇزبېك‎',
	},
	ve: {
		name: 'Venda',
		nativeName: 'Tshivenḓa',
	},
	vi: {
		name: 'Vietnamese',
		nativeName: 'TiếngViệt',
	},
	vo: {
		name: 'Volapük',
		nativeName: 'Volapük',
	},
	wa: {
		name: 'Walloon',
		nativeName: 'Walon',
	},
	cy: {
		name: 'Welsh',
		nativeName: 'Cymraeg',
	},
	wo: {
		name: 'Wolof',
		nativeName: 'Wollof',
	},
	fy: {
		name: 'WesternFrisian',
		nativeName: 'Frysk',
	},
	xh: {
		name: 'Xhosa',
		nativeName: 'isiXhosa',
	},
	yi: {
		name: 'Yiddish',
		nativeName: 'ייִדיש',
	},
	yo: {
		name: 'Yoruba',
		nativeName: 'Yorùbá',
	},
	za: {
		name: 'Zhuang,Chuang',
		nativeName: 'Saɯcueŋƅ,Sawcuengh',
	},
	dec: {
		iso: 'dec',
		name: 'german for children',
		nativeName: 'Deutsch (kindgerecht)',
	},
	des: {
		iso: 'des',
		name: 'simple german',
		nativeName: 'Leichte Sprache',
	},
	ens: {
		iso: 'ens',
		name: 'plain english',
		nativeName: 'Plain English',
	},
	frs: {
		iso: 'frs',
		name: 'plain french',
		nativeName: 'Simple Français',
	},
};
